import { Box, Flex } from 'components/elements'
import FlagIcon from '@mui/icons-material/Flag'
import { Link } from 'react-router-dom'
import { routes } from 'configs/constants'
import { TERMINOLOGY } from 'utils/enum'
const PageNotFound = () => {
  return (
    <>
      <Flex justify={'center'} direction={'column'} align={'center'} css={PageNotFoundCSS}>
        <Box css={IconCss}>
          <FlagIcon style={{ fontSize: '9rem' }} />
        </Box>
        <Box as="h3">{TERMINOLOGY.warranty.singular} not found</Box>
        <Box as="p">You do not have any {TERMINOLOGY.warranty.singular.toLowerCase()} as yet.</Box>
        <Box as="p">
          For more details, please contact our
          <Link to={routes.support} style={{ textDecoration: 'underline', margin: '0 0.5rem' }}>
            Support Team
          </Link>
          or fill up an
          <Link to={routes.insuranceForm} style={{ textDecoration: 'underline', margin: '0 0.5rem' }}>
            {TERMINOLOGY.warranty.singular} Application Form
          </Link>
        </Box>
      </Flex>
    </>
  )
}

const PageNotFoundCSS = {
  minHeight: 'calc(100vh - 12.75rem)',
  svg: {
    fill: '$primary',
    marginLeft: '-1rem',
    marginTop: '-1rem',
  },
}
const IconCss = {
  width: '11rem',
  height: '11rem',
  borderRadius: '50%',
  backgroundColor: '$white',
  padding: '2rem',
  marginBottom: '1.5rem',
}
export default PageNotFound
